import { faBell } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

import "./PortfolioButton.scss";
import { Button, Image } from 'react-bootstrap'
import "../../../src/style.scss"
import { useTranslation } from 'react-i18next';
import chartImage from '../../assets/img/solarpiechart.svg';
import { useNavigate } from 'react-router-dom';



export default function PortfolioButton() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const openPortfolio = () => {
        console.log('openPortfolio')
        // navigate('/PortfolioPage')

        navigate('/Portfolio')
    }
    

    return (
        <div className='portfolioButtonContainer'>
            <Button className='portfolioButton ' onClick={() => openPortfolio()}>
                <Image src={chartImage} className='chartImage' />
                {t('header.portfolio')}
            </Button>
        </div>
    )
}
